// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"reports_innerContainer__1jf0I"};